// Turbolinks caches a snapshot of the page before navigating away. If the
// mobile sidebar drawer is open at that moment, the cached snapshot would
// restore with a stuck backdrop — strip the offcanvas state before caching.
document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll(".offcanvas-backdrop").forEach((el) => el.remove());
  document.querySelectorAll(".offcanvas.show").forEach((el) => el.classList.remove("show"));
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
});

// The drawer is hidden by the d-lg-none media query when the viewport grows past
// lg, but Bootstrap still considers it open and leaves its backdrop behind
// (offcanvas-lg would handle this, Bootstrap 5.2+). Close it properly on resize.
window.addEventListener("resize", () => {
  if (window.innerWidth < 992) return;
  document.querySelectorAll(".offcanvas.show").forEach((el) => {
    window.bootstrap?.Offcanvas?.getInstance(el)?.hide();
  });
});
